export function getUserRole() {
	const userRole = JSON.parse(atob(localStorage.getItem('role') || '""'));

	if (typeof userRole === 'string') return userRole;
}

export function getUsername() {
	const username = JSON.parse(atob(localStorage.getItem('username') || '""'));

	return typeof username === 'string' ? username : null;
}

export function getCompleteName() {
	const name = JSON.parse(atob(localStorage.getItem('name') || '""'));
	const surname = JSON.parse(atob(localStorage.getItem('surname') || '""'));
	const completeName = `${name}  ${surname}`

	return typeof completeName === 'string' ? completeName : null;
}

export function isUserAdmin() {
	const userRole = JSON.parse(atob(localStorage.getItem('role') || '""'));
	return userRole === 'admin' ? true : false;
}

export function isSimepar() {
	const userCompany = JSON.parse(atob(localStorage.getItem('company')  || '""'));
	return userCompany === 'SIMEPAR';
}

export function isContributorPerabiru() {
	const useName = JSON.parse(atob(localStorage.getItem('username')  || '""'));
	return useName === 'jeankukla';
}

export function getUserCompany() {
	try {
		const userCompany = JSON.parse(
			atob(localStorage.getItem('company') || '""')
		);

		return typeof userCompany === 'string' ? userCompany.trim() : null;
	} catch (error) {
		console.error('Erro ao ler company do localStorage:', error);
		return null;
	}
}

export function canViewPendingReviewPins() {
	const company = getUserCompany();
	if (!company) return false;

	const normalizedCompany = company.toUpperCase();
	return !['SIMEPAR', 'IAT'].includes(normalizedCompany);
}
